export default __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmYUtfBxc4AMP6lbBP.a6804f92.woff2";